<template>
  <div>
    <!-- 登录 Start -->
    <div v-show="!showRegisters">
      <div class="title">学生端登录</div>

      <el-form ref="loginForm" :model="form" :rules="rules" size="medium" label-width="100px">
        <el-form-item>
          <section class="signIn">
            <div @click="signInTabs.active = 2"
                 class="signIn-tab"
                 :class="signInTabs.active === 2 && 'is-active'"
            >
              密码登录
            </div>
            <div @click="signInTabs.active = 1"
              class="signIn-tab"
              :class="signInTabs.active === 1 && 'is-active'"
            >
              验证码登录
            </div>
          </section>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="form.phone" placeholder="请输入手机号" @keyup.enter.native="onClickConfirm" style="width: 244px;" clearable></el-input>
        </el-form-item>
        <el-form-item v-if="signInTabs.active === 1" label="验证码" prop="code">
          <el-input v-model="form.code" placeholder="请输入验证码" @keyup.enter.native="onClickConfirm" style="width: 244px;" clearable></el-input>
          <el-button v-show="!countDown" style="color: var(--primaryColor);border: none;" @click="getSMSCodeByPhone">
            获取验证码
          </el-button>
          <el-button v-show="countDown" style="color: var(--primaryColor);border: none;">
            {{ countDown }}s
          </el-button>
        </el-form-item>
        <el-form-item v-if="signInTabs.active === 2" label="密码" prop="password">
          <el-input v-model="form.password" placeholder="请输入密码" @keyup.enter.native="onClickConfirm" type="password" style="width: 244px;" clearable></el-input>
          <el-button style="color: var(--primaryColor); border: none;" @click="showForgotPassword = true">忘记密码？</el-button>
        </el-form-item>

        <el-form-item prop="isConsentAgreement">
          <el-checkbox v-model="form.isConsentAgreement">我已阅读并同意</el-checkbox>
          <span @click="$refs.privacyDialog.open()" style="color: var(--primaryColor); cursor: pointer;">《用户协议和免责说明》</span>
        </el-form-item>
        <el-form-item>
          <el-button class="submit" style="" type="primary" @click.stop="onClickConfirm">登录</el-button>
          <p @click="showRegisters = true" class="registers">首次登录请先完成账户注册>>></p>
        </el-form-item>
      </el-form>
<!--      &lt;!&ndash; 第三方登录 &ndash;&gt;-->
<!--      <div class="other-login">-->
<!--        <p style="margin-top: 100px;"></p>-->
<!--        <el-divider>其他方式</el-divider>-->
<!--        <a-->
<!--          href="https://open.weixin.qq.com/connect/qrconnect?appid=wx300c5c2045683f30&redirect_uri=http://www.51mydoor.com&response_type=code&scope=snsapi_login&state=STATE#wechat_redirect">-->
<!--          <img title="微信" alt="微信"-->
<!--            src="//sf6-scmcdn2-tos.pstatp.com/xitu_juejin_web/img/wechat.e0ff124.svg"-->
<!--            class="oauth-btn" style="margin-left: 47.5%;" />-->
<!--        </a>-->
<!--        <p style="text-align: center;font-size: 15px;color: #808080;">已完成注册但未绑定微信的用户请先使用手机号登录后绑定微信</p>-->
<!--      </div>-->
    </div>
    <!-- 登录 end -->
    <!-- 前往注册 -->
    <StudentSignIn v-show="showRegisters"></StudentSignIn>
    <Privacy @confirm="form.isConsentAgreement = true" ref="privacyDialog" />
    <StuForgotPassword title="找回密码"
         ref="forgotPassword"
         :dialog-visible.sync="showForgotPassword"
    />

    <el-dialog width="800px" :visible.sync="isShowSystemMsg" :show-close="false" title="系统通知"
               :close-on-click-modal="false" :close-on-press-escape="false">
      <div>
        <strong>真实成绩与位次填写：</strong><br/>
        --2026年6月25日12:00起，系统将提示考生填写本人真实高考成绩及全省位次。<strong>信息一经确认，不可修改。</strong>考生成功填写真实高考成绩及位次后，后续各批次志愿志愿方案，将严格依据考生填写的成绩及位次生成。<br/>
        <br/><br/><strong>招生计划更新：</strong><br/>
        --系统根据陕西省教育考试院印发的《2026年普通高校在陕招生物理组/历史组分校分专业计划汇编》已经更新本科提前批和普通批次2026年最新专业组设置、招生专业及招生计划。<br/>
        <br/><br/><strong>方案处理规则：</strong><br/>
        --最新招生计划更新后，考生原有模拟志愿方案仅可查看，不可修改。
        <br/>--考生需依据已确认的成绩、位次及最新招生计划，制定正式志愿方案。<br/><br/><br/>
        <strong>请各位考生务必仔细阅读本通知，系统功能调整旨在为您提供更精准、更有效的志愿填报服务，请予以理解与配合。</strong>

<!--        <strong>尊敬的各位用户：</strong><br/>-->
<!--        <br/>为了给您提供更加稳定、高效的服务体验，我司计划于 2026年5月10日（星期日）13:00 至 24:00 对“门道智能填报系统（学生版）”进行系统升级维护。-->
<!--        <br/>在此期间，系统可能出现以下情况：-->
<!--        <br/>登录缓慢或暂时失败；-->
<!--        <br/>页面加载延时、操作响应卡顿；-->
<!--        <br/>部分功能使用不稳定。-->
<!--        <br/>受升级影响，建议您尽量避开上述时段登录或使用系统。如您有重要的志愿填报或数据保存操作，请提前完成，以免耽误您的使用安排。-->
<!--        <br/>给您带来的不便，我们深表歉意。升级完成后，系统将以更优的性能为您服务。-->
<!--        <br/>感谢您的理解与支持！-->

<!--        <br/>特此公告。-->
<!--        <br/><br/><strong>门道智能填报系统运营团队</strong>-->
<!--        <br/><strong>2026年5月10日</strong>-->
        <br/><br/>
        <div class="flex-center">
          <el-button type="primary" style="" @click="closeSystemMsg()">我已知晓</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { request } from "@/util/request.js"
import StudentSignIn from "./StudentSignIn"
import Privacy from "@/components/Privacy"
import StuForgotPassword from "@/views/login/components/StuForgotPassword.vue";
export default {
  inject: ['reload'],
  inheritAttrs: false,
  components: {StuForgotPassword, StudentSignIn, Privacy },
  data() {
    return {
      signInTabs: {
        active: 2,
      },
      showForgotPassword: false,
      showRegisters: false, // 注册页
      submitLoading: false,
      countDown: '', // 倒计时展示
      form: {
        phone: undefined,
        code: undefined,
        password: undefined,
        isConsentAgreement: undefined,
      },

      rules: {
        phone: [
          { required: true, message: '请输入手机号', trigger: 'change' },
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'change' },
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'change' },
        ],
        isConsentAgreement: [
          {
            validator: function validateAccept(rule, value, callback) {
              value ? callback() : callback(new Error())
            },
            message: '请您阅读并同意《用户协议和免责声明》',
            trigger: 'change'
          },
        ],
      },
      isShowSystemMsg: false
    }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    getSMSCodeByPhone() {
      this.$refs['loginForm'].validateField('phone', (errorMessage) => {
        if (errorMessage) {
          return this.$message.error(errorMessage);
        }
        const TIME_COUNT = 60
        request({
          method: 'POST',
          url: 'sysUser/yan',
          params: {
            phone: this.form.phone
          }
        }).then(res => {
          if (![null, 0].includes(res.code)) {
            return this.$message.error(res.msg);
          }
          if (!this.timer) {
            this.countDown = TIME_COUNT;
            this.timer = setInterval(() => {
              if (this.countDown > 0 && this.countDown <= TIME_COUNT) {
                this.countDown--;
              } else {
                clearInterval(this.timer);
                this.timer = null;
              }
            }, 1000)
          }
          this.$message.success(res.msg);
        })
      })
    },

    aaa() {
      console.log('1', 1);
    },
    onClickConfirm() {
      this.$refs['loginForm'].validate(valid => {
        if (!valid) return
        this.submitLoading = true
        request({
					method: 'POST',
					url: 'sysUser/login',
					params: {
            ...this.form,
            isConsentAgreement: undefined,
            // 1 验证码 2 密码
            code: this.signInTabs.active === 1 ? this.form.code: undefined,
            password: this.signInTabs.active === 2 ? this.form.password : undefined,
          }
				}).then(res => {
          console.log(res);
          if (![0, 200].includes(res.code)) {
            return this.$message.error(res.msg)
          }
          this.reload();
          sessionStorage.setItem(res.data.tokenInfo.tokenName, res.data.tokenInfo.tokenValue)
          sessionStorage.setItem('userId', res.data.user.userId)
          sessionStorage.setItem('user', JSON.stringify(res.data.user))
          sessionStorage.setItem('loginStu', JSON.stringify(res.data.stu))
          this.$store.dispatch('login', res.data)
          this.isShowSystemMsg =true;
        }).finally(() => {
          this.submitLoading = false
        })
      })
    },

    closeSystemMsg(){
      this.$message.success({
        showClose: true,
        message: '登录成功！',
        duration: 2000
      });
      this.$router.push({ path: '/policy' });
    }
  }
}

</script>
<style lang="stylus" scoped>
@import './common.styl'
.flex-center {
  display: flex;
  justify-content: center;
}
.submit
  width: 244px;
  font-size: 18px;
  font-weight: 400;
  color: #fff;
.registers
  margin-top 29px
  font-size: 18px;
  font-weight: 400;
  color: PrimaryColor;
  line-height: 36px;
  cursor pointer

.signIn
  display flex
  gap: 0 95px
  &-tab
    padding-bottom: 10px;
    color: #191b1f;
    position: relative;
    cursor: pointer;
    font-size: 16px;
    line-height: 16px;
    &::after {
      background-color: PrimaryColor;
      bottom: 0;
      content: "";
      display: block;
      height: 3px;
      position: absolute;
      width: 100%;
      transform: scaleX(0);
      opacity: 0;
      border-radius: 4px;
      transition: all .2s cubic-bezier(.18,.89,.17,.88), opacity .15s ease;
    }
    &:hover, &.is-active
      color: PrimaryColor;
      &::after
        opacity: 1;
        transform: scaleX(1);
</style>
